import mustache from 'mustache';

const template = `
<div class="own-car-information">
  {{#inputs}}
  <div class="row stage-form-row stage-form-border-left">
    <div class="col-12 stage-form-label">
      <label class="stage-form-label stage-required" for="{id}">{{label}}</label>
    </div>
    <div class="col-12">
      <div class="stage-form-status  stage-required">
        <input type="text" name="{{name}}" id="{{id}}" class="stage-form-field" value="">
      </div>
    </div>
  </div>
  {{/inputs}}
</div>
`;

/**
 * Class handles legacy car page contact form that is implemented by using Stage Form.
 * Idea is to show two extra fields if user chooses 'Vaihdossa' from the dropdown.
 * And gives user a change to fill their own car information to shown fields.
 */
export default class CarContactForm {

  #dom = {};

  constructor(element) {
    this.#dom.element = element;
  }

  /**
   * Find elements from the DOM.
   */
  findElements() {
    this.#dom.hiddenFields = [
      this.#dom.element.querySelector('#own_car_kilometerage'),
      this.#dom.element.querySelector('#own_car_license')
    ];
    this.#dom.selectInterested = this.#dom.element.querySelector('select#interest');
    this.#dom.target = this.#dom.selectInterested.closest('.stage-form-row');
  }

  addEventListeners() {
    this.#dom?.selectInterested?.addEventListener('change', this.handleSelectInterestedChange.bind(this));
  }

  /**
   * Handle select interested change event.
   * @param {Event} event - event object
   */
  handleSelectInterestedChange(event) {
    const {value} = event.target;
    const show = value?.toLowerCase() === 'vaihdosta';

    if(show && !this.#dom.ownCarInformation) {
      this.renderOwnCarInformation();
    } else {
      this.#dom.ownCarInformation?.classList?.toggle('d-none', !show)
    }
  }

  /**
   * Render own car information fields.
   */
  renderOwnCarInformation() {
    const inputs = this.#dom.hiddenFields.map(field => {
      return {
        label: field.dataset.label,
        name: field.name,
        id: field.id
      }
    })

    this.#dom.hiddenFields.forEach( field => field?.remove());//Remove unused hidden inputs

    const data = { inputs}

    this.#dom.target.insertAdjacentHTML('afterend', mustache.render(template, data))
    this.#dom.ownCarInformation = this.#dom.element.querySelector('.own-car-information');
  }
}
